'use strict';

const Analytics = require('./analytics');

class AnalyticsMinicart extends Analytics {
    init (globalContainer, helperContainer) {
        this.logName = 'AnalyticsMinicart';
        super.init(globalContainer, helperContainer);

        this.prepareObservers();
    }

    prepareMinicartObservers (data) {
        let _self = this;
        $('#checkout-button-goto-cart, .button-goto-bag').on('click', function (e) {
            _self.quickImpressionSender.pushMinicartCheckoutClickInteraction('go_to_shopping_bag');
        });

        $('.js_paypal_button').on('click touchstart', function (e) {
            _self.quickImpressionSender.pushMinicartCheckoutClickInteraction('pay_with_paypal');
        });
        $('#checkout-button-secure-checkout').on('click touchstart', function (e) {
            _self.quickImpressionSender.pushMinicartCheckoutClickInteraction('go_to_shopping_bag');
        });
    }

    prepareObservers () {
        var _self = this;

        $('body').on('minicart:open', function (e, data) {
            _self.log('Minicart Open', true);
            _self.prepareMinicartObservers(data);
        });

        $('body').on('minicart:close', function (e, data) {
            _self.log('Minicart Close', true);
        });
    }
}

const obj = new AnalyticsMinicart();
module.exports = obj;
